import React from 'react';
import { object, number } from 'prop-types';
import SafePureComponentWrapper from '../shared/SafePureComponent';
import SeoScript from './SeoScript';
import { shouldFormatFaq, formatFAQ } from './formatFaq';
import { shouldFormatSeo, formatSeo } from './formatSeo';
import { formatBreadcrumbs } from './formatBreadcrumbs';

const Seo = ({ seo, faq, packagesCount }, { general, pathfinderWrapper }) => (
    <>
        <SeoScript scriptContent={formatBreadcrumbs({ general, pathfinderWrapper })}/>
        {shouldFormatSeo(seo) && <SeoScript scriptContent={formatSeo({ seo, pathfinderWrapper, packagesCount, general })}/>}
        {shouldFormatFaq(faq) && <SeoScript scriptContent={formatFAQ(faq)}/>}
    </>
);

Seo.propTypes = {
    faq: object,
    seo: object,
    packagesCount: number
};

Seo.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { Seo };
export default SafePureComponentWrapper(Seo);
